module.exports = __webpack_public_path__ + "dan-a2381647dc5fe8a1e32d2624909ebdd9.webp";